import React, { useEffect, useState } from 'react';
import '../styles/StripeLink.css';
import { checkOnAuthStateChanged, cloudFunctionV2 } from '../functions';
import { Header, Footer, PricingCard, Input } from '../components';
import { pricingTiers } from '../defaults';
import { useNavigate } from 'react-router-dom';

function StripeLink() {
    const [loggedIn, setLoggedIn] = useState(null);
    const [email, setEmail] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [customerId, setCustomerId] = useState("");
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const origin = window.location.origin;

    useEffect(() => {
        document.title = "Stripe Link | Clozers";

        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                const admins = JSON.parse(process.env.REACT_APP_ADMINIDS);
                const isAdmin = admins.includes(user.userId);
                if ( isAdmin === false ) {
                    navigate("/");
                }
                else {
                    if ( origin.includes("localhost") ) {
                        window.open("https://app.clozers.co/stripe-link", "_self");
                    }
                    setLoggedIn(true);
                }
            }
            else {
                navigate("/login");
            }

            setLoading(false);
        };

        fetchUserData();
    }, [navigate, origin]);

    const getCheckoutLink = async(item) => {
        setDisabled(true);
        const url = process.env.REACT_APP_GENERATE_STRIPE_CHECKOUT;
        // Retrieve the referral code that the Tolt script (tolt.js) drops on the window object
        const toltReferral = window?.tolt_referral || null;
        // Build metadata; only include the referral if it exists
        const metadata = {
            companyId: companyId,
            credits: item.credits,
        };
        if (toltReferral) {
            metadata.tolt_referral = toltReferral;
        }
        const params = {
            mode: "live",
            priceId: item.liveId,
            successURL: `https://app.clozers.co/`,
            cancelURL: `https://app.clozers.co/pricing`,
            email: email,
            customerId: customerId,
            metadata,
        };

        // Add this to metadata
        // tolt_referral: code

        const queryData = await cloudFunctionV2(url, params);
        if ( queryData.status === 200 ) {
            const data = queryData.data;
            const url = data.url;
            window.open(url, "_self");
        }
        else {
            console.log(queryData);
        }
        setDisabled(false);
    };
    
    const onChangeCustomerId = (val) => {
        setCustomerId(val);
    };

    const onChangeCompanyId = (val) => {
        setCompanyId(val);
    };

    const onChangeEmail = (val) => {
        setEmail(val);
    };

    return (
        <div className="stripe-link-outer-container">
            <Header
                loggedIn={loggedIn}
            />
            {
                loading === true ?
                <div className="stripe-link-inner-container">
                </div>
                :
                loading === false ?
                <div className="stripe-link-inner-container">
                    <div className="stripe-link-form-container">
                        <Input
                            label={"Customer ID"}
                            labelType={"default"}
                            info={false}
                            value={customerId}
                            onChange={(e) => onChangeCustomerId(e.target.value)}
                            placeholder={"cus_12345"}
                            type="text"
                            leftUnit={null}
                            rightUnit={null}
                            unitSwitch={false}
                            leftUnitSelected={true}
                            unitSwitchFunc={null}
                            disabled={false}
                            multiline={false}
                            error={false}
                            onMouseEnter={null}
                            onMouseLeave={null}
                            reset={false}
                            resetFunc={null}
                            resetPosition={null}
                            focusMultiline={false}
                            prompt={false}
                        />
                        <Input
                            label={"Company ID"}
                            labelType={"default"}
                            info={false}
                            value={companyId}
                            onChange={(e) => onChangeCompanyId(e.target.value)}
                            placeholder={"ABC123"}
                            type="text"
                            leftUnit={null}
                            rightUnit={null}
                            unitSwitch={false}
                            leftUnitSelected={true}
                            unitSwitchFunc={null}
                            disabled={false}
                            multiline={false}
                            error={false}
                            onMouseEnter={null}
                            onMouseLeave={null}
                            reset={false}
                            resetFunc={null}
                            resetPosition={null}
                            focusMultiline={false}
                            prompt={false}
                        />
                        <Input
                            label={"Email"}
                            labelType={"default"}
                            info={false}
                            value={email}
                            onChange={(e) => onChangeEmail(e.target.value)}
                            placeholder={"test@test.com"}
                            type="email"
                            leftUnit={null}
                            rightUnit={null}
                            unitSwitch={false}
                            leftUnitSelected={true}
                            unitSwitchFunc={null}
                            disabled={false}
                            multiline={false}
                            error={false}
                            onMouseEnter={null}
                            onMouseLeave={null}
                            reset={false}
                            resetFunc={null}
                            resetPosition={null}
                            focusMultiline={false}
                            prompt={false}
                        />
                    </div>
                    <div className="pricing-body-container">
                        {
                            pricingTiers.map((item, index) =>
                                <PricingCard
                                    item={item}
                                    key={index}
                                    cta={() => getCheckoutLink(item)}
                                    disabled={companyId === "" || customerId === "" || email === "" ? true : disabled}
                                />
                            )
                        }
                    </div>
                </div>
                :
                null
            }
            <Footer />
        </div>
    )
};

export default StripeLink;